// src/utils/dateHelpers.js

/**
 * Dodaje dni do daty ISO
 */
export function isoAddDays(iso, n) {
    const d = new Date(iso + 'T00:00:00');
    d.setDate(d.getDate() + n);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

/**
 * Zwraca nazwę dnia tygodnia
 */
export function getWeekdayName(dateStr) {
    const days = ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb'];
    return days[new Date(dateStr).getDay()];
}

/**
 * Klucz lokalizatora wydarzenia (kolumna, DnD, patch needed, notatki).
 * Preferuje gId z Google Calendar, aby rozróżnić wydarzenia o tej samej nazwie w jednym dniu.
 */
export function buildEventLocatorKey(date, evOrParts = {}) {
    const cal = evOrParts.calendarId ?? 'noCal';
    if (evOrParts.gId) {
        return `${date}::gid:${evOrParts.gId}::${cal}`;
    }
    return `${date}::${evOrParts.event || evOrParts.eventName || ''}::${cal}`;
}

/**
 * Parsuje klucz lokalizatora wydarzenia.
 */
export function parseEventLocatorKey(key) {
    const isPlaceholder = key.includes('__placeholder__') || key.includes('__placeholder_');
    const gidMatch = String(key).match(/^(\d{4}-\d{2}-\d{2})::gid:([^:]+)::(.+)$/);
    if (gidMatch) {
        const cal = gidMatch[3];
        return {
            date: gidMatch[1],
            gId: gidMatch[2],
            eventName: undefined,
            calendarId: cal && cal !== 'noCal' ? cal : undefined,
            isPlaceholder,
        };
    }
    if (key.includes('::')) {
        const [kDate, kEvent, kCal] = key.split('::');
        return {
            date: kDate,
            eventName: kEvent,
            gId: undefined,
            calendarId: kCal && kCal !== 'noCal' ? kCal : undefined,
            isPlaceholder,
        };
    }
    const [kDate, ...rest] = key.split('_');
    return {
        date: kDate,
        eventName: rest.join('_'),
        gId: undefined,
        calendarId: undefined,
        isPlaceholder,
    };
}

/**
 * Znajduje indeks wydarzenia na liście dnia (gId ma pierwszeństwo przed nazwą).
 */
/** Obiekt przekazywany do updateEventStaff / updateNeededForEvent (nigdy indeks z UI). */
export function eventRefFromEv(ev, fallbackCalendarId) {
    if (!ev) return null;
    const calendarId = ev.calendarId ?? fallbackCalendarId;
    if (ev.gId) {
        return { gId: ev.gId, event: ev.event, calendarId };
    }
    return { event: ev.event, calendarId };
}

export function resolveEventIndex(list, { gId, eventName, calendarId } = {}) {
    if (!Array.isArray(list)) return -1;
    const cal = String(calendarId ?? '');
    if (gId) {
        const byGid = list.findIndex(
            (e) => e.gId === gId && String(e.calendarId ?? '') === cal
        );
        if (byGid >= 0) return byGid;
        const byGidOnly = list.findIndex((e) => e.gId === gId);
        if (byGidOnly >= 0) return byGidOnly;
    }
    if (eventName != null && eventName !== '') {
        return list.findIndex(
            (e) =>
                String(e.event || '') === String(eventName) &&
                String(e.calendarId ?? '') === cal
        );
    }
    return -1;
}

/**
 * Generuje klucz dla notatki eventu
 */
export function getNoteKey(dateStr, ev) {
    return buildEventLocatorKey(dateStr, {
        gId: ev?.gId,
        event: ev?.event,
        calendarId: ev?.calendarId ?? 'noCal',
    });
}

/**
 * Generuje klucz dla patch needed
 */
export function keyForPatch(date, eventName, calId, gId) {
    if (gId) {
        return `${date}::gid:${gId}::${calId || 'noCal'}`;
    }
    return `${date}::${eventName}::${calId || 'noCal'}`;
}

/**
 * Parsuje klucz przypisania (assignment key)
 */
export function parseAssignmentKey(key) {
    return parseEventLocatorKey(key);
}

